import { useLocation } from 'react-router-dom'
import { getSection } from 'app/utils'

export function useFilterSection() {
    const { pathname } = useLocation()
    return getSection(pathname)
}
